'use client';

import { CenteredPageLayout } from '@/layout/CenteredPageLayout';
import { BrowseInvestmentProperties } from './BrowseInvestmentProperties';
import { BuyingSlideshow } from './BuyingSlideshow';
import { DiscussBuyingForm } from './DiscussBuyingForm';

const BuyPage = () => {
  return (
    <CenteredPageLayout title="BUYING PROPERTY WITH MARSHALL REDDICK">
      <div className="space-y-8">
        <BuyingSlideshow />
        <DiscussBuyingForm />
        <BrowseInvestmentProperties />
      </div>
    </CenteredPageLayout>
  );
};

export default BuyPage;
